<template>
  <v-card>
    <v-card-title class="primary white--text">
      {{ isEditing ? $t('editPermitNumber') : $t('addPermitNumber') }}
    </v-card-title>

    <v-card-text class="pt-6">
      <v-form ref="form" v-model="formValid">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="permitNumberLocal.number"
              :label="$t('permitNumber')"
              :rules="[rules.required]"
              color="black"
              counter
              :maxlength="maxPermitNumberLength"
            />
          </v-col>

          <v-col cols="12">
            <DatePicker
              :date="permitNumberLocal.expiresOn"
              :startDate="startDate"
              :label="$t('expiresOn')"
              @date-picked="onDateSelected"
              :clearable="true"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="pb-4 px-0 mt-4">
      <v-row justify="end" class="px-3">
        <v-col cols="auto">
          <v-btn
            text
            color="black"
            @click="cancel"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn
            elevation="0"
            color="primary"
            @click="save"
            :disabled="!enableSaveButton"
          >
            {{ isEditing ? $t('save') : $t('add') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules'
import { localToUTC } from '@/utils/DateFormatter.js'
import moment from 'moment'

export default {
  name: 'PermitNumberDialog',

  components: {
    DatePicker: () => import('@/components/helper/DatePicker.vue')
  },

  props: {
    permitNumber: {
      type: Object,
      required: false
    }
  },

  data: () => ({
    permitNumberLocal: {
      number: '',
      expiresOn: null,
      permitNumberId: undefined,
      uuid: undefined
    },
    formValid: false,
    rules: fieldRules.rules,
    maxPermitNumberLength: 14 // Server allows 32; this is a product limit, not a storage one
  }),

  computed: {
    isEditing () {
      return !!this.permitNumber?.permitNumberId || !!this.permitNumber?.number
    },
    enableSaveButton () {
      return this.permitNumberLocal.number.trim().length > 0 && this.permitNumberLocal.expiresOn !== null
    },
    startDate () {
      return moment().add(1, 'year').toISOString()
    }
  },

  created () {
    if (this.permitNumber) {
      this.permitNumberLocal = {
        number: this.permitNumber.number ?? '',
        expiresOn: this.permitNumber.expiresOn ?? null,
        permitNumberId: this.permitNumber.permitNumberId ?? undefined,
        uuid: this.permitNumber.uuid
      }
    }
  },

  methods: {
    onDateSelected (date) {
      this.permitNumberLocal.expiresOn = localToUTC(date)
    },

    save () {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.permitNumberLocal)
      }
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
